import { useServices } from "@/hooks/api/services/useServices";
import { Button, makeStyles, tokens } from "@fluentui/react-components";
import React from "react";

type ServiceButtonProps = {
  text: string;
  onClick?: (serviceId?: string) => void;
};

export const ServiceButton: React.FC<ServiceButtonProps> = ({ text, onClick }) => {
  const styles = useStyles();
  const { data: servicesData } = useServices();

  const handleClick = () => {
    const serviceName = text.replace(/^@ /, "");

    const service = servicesData?.find((service: { name: string; id: string; }) => service.name === serviceName);

    if (service && onClick) {
      onClick(service.id);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <Button
      appearance="outline"
      className={styles.serviceButton}
      onClick={handleClick}
    >
      {text}
    </Button>
  );
};

const useStyles = makeStyles({
  serviceButton: {
    minWidth: "180px",
    border: `1px solid ${tokens.colorBrandStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    color: tokens.colorBrandForegroundLink,
    backgroundColor: tokens.colorBrandBackgroundInverted,
    ":hover": {
      color: tokens.colorBrandForegroundLinkHover,
      backgroundColor: tokens.colorBrandBackgroundInvertedHover,
      textDecoration: "none",
    },
  },
});
